var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"tw-px-4 lg:tw-px-8 tw-py-5 tw-border-t-2 tw-border-t-gray-200 tw-space-x-5"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }